var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.pageLoading)?_c('div',{staticClass:"pageLoading pageFlexCenter",style:({backgroundColor: _vm.bgColor})},[_c('van-button',{attrs:{"type":"default","size":"large","loading":_vm.$store.state.pageLoading}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }